import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { tasksAPI } from '../../services/api';
import { fmtDate } from '../../utils/dateUtils';
import { taskSourceLabel } from '../../utils/taskSource';

const STATUS_COLORS = { pending: 'orange', in_progress: 'blue', completed: 'green', overdue: 'red', cancelled: 'gray' };
const PRIORITY_COLORS = { low: 'green', medium: 'blue', high: 'orange', urgent: 'red' };

export default function MyTasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const load = (status) => {
    setLoading(true);
    tasksAPI.list(status ? { mine: true, task_status: status } : { mine: true })
      .then(({ data }) => setTasks(data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(filter); }, [filter]);

  return (
    <div className="page">
      <div className="page-header">
        <h2>My Tasks</h2>
        <Link to="/employee/tasks/new" className="btn btn-primary">+ New Task</Link>
      </div>

      <div className="filter-bar">
        {['', 'pending', 'in_progress', 'completed', 'overdue'].map((s) => (
          <button
            key={s}
            className={`filter-btn${filter === s ? ' active' : ''}`}
            onClick={() => setFilter(s)}
          >
            {s ? s.replace('_', ' ') : 'All'}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="page-loading">Loading...</div>
      ) : tasks.length === 0 ? (
        <div className="empty-state">No tasks found.</div>
      ) : (
        <div className="task-grid">
          {tasks.map((t) => (
            <Link to={`/employee/tasks/${t.id}`} key={t.id} className="task-card">
              <div className="task-card-header">
                <span className={`badge badge-${PRIORITY_COLORS[t.priority]}`}>{t.priority}</span>
                <span className={`badge badge-${STATUS_COLORS[t.status]}`}>{t.status.replace('_', ' ')}</span>
                {t.is_delayed && <span className="badge badge-red">DELAYED</span>}
              </div>
              <h4 className="task-card-title">{t.title}</h4>
              {t.description && (
                <>
                  <p className={`task-card-desc${expanded[t.id] ? ' expanded' : ''}`}>{t.description}</p>
                  {t.description.length > 120 && (
                    <button type="button" className="task-readmore" onClick={(e) => toggleExpand(t.id, e)}>
                      {expanded[t.id] ? 'Read less' : 'Read more'}
                    </button>
                  )}
                </>
              )}
              <div className="task-card-footer">
                <span>{t.source === 'hr_assigned' ? '📌' : '👤'} {taskSourceLabel(t)}</span>
                {t.deadline && (
                  <span className={t.is_delayed ? 'text-danger' : 'text-muted'}>
                    📅 {fmtDate(t.deadline, true)}
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
